import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const senecAlertTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            action: {
                padding: "8px 0 0 16px",
            },
            filledSuccess: {
                border: `1px solid ${theme.palette.neutralGray30.main}`,
                backgroundColor: theme.palette.senecSecondary.limeGreen,
                color: theme.palette.white.main,
                "& .MuiAlert-icon": {
                    color: theme.palette.white.main,
                },
                "& .MuiIconButton-root": {
                    background: theme.palette.limeGreen30.main,
                    borderRadius: "12px",
                },
            },
            outlinedSuccess: {
                border: `1px solid ${theme.palette.neutralGray30.main}`,
                background: theme.palette.limeGreen00.main,
                color: theme.palette.limeGreen80.main,
                "& .MuiAlert-icon": {
                    color: theme.palette.senecSecondary.limeGreen,
                },
                "& .MuiIconButton-root": {
                    background: theme.palette.limeGreen30.main,
                    borderRadius: "12px",
                    color: theme.palette.white.main,
                },
            },
            filledError: {
                border: `1px solid ${theme.palette.neutralGray30.main}`,
                backgroundColor: theme.palette.red,
                color: theme.palette.white.main,
                "& .MuiAlert-icon": {
                    color: theme.palette.white.main,
                },
                "& .MuiIconButton-root": {
                    background: theme.palette.tarocco30.main,
                    borderRadius: "12px",
                    color: theme.palette.white.main,
                },
            },
            outlinedError: {
                border: `1px solid ${theme.palette.neutralGray30.main}`,
                background: theme.palette.tarocco00.main,
                color: theme.palette.tarocco80.main,
                "& .MuiAlert-icon": {
                    color: theme.palette.red.main,
                },
                "& .MuiIconButton-root": {
                    background: theme.palette.tarocco30.main,
                    borderRadius: "12px",
                    color: theme.palette.white.main,
                },
            },
            filledWarning: {
                border: `1px solid ${theme.palette.neutralGray30.main}`,
                backgroundColor: theme.palette.sunYellow50.main,
                color: theme.palette.white.main,
                "& .MuiAlert-icon": {
                    color: theme.palette.white.main,
                },
                "& .MuiIconButton-root": {
                    background: theme.palette.sunYellow30.main,
                    borderRadius: "12px",
                    color: theme.palette.white.main,
                },
            },
            outlinedWarning: {
                border: `1px solid ${theme.palette.neutralGray30.main}`,
                background: theme.palette.sunYellow00.main,
                color: theme.palette.sunYellow80.main,
                "& .MuiAlert-icon": {
                    color: theme.palette.yellow.main,
                },
                "& .MuiIconButton-root": {
                    background: theme.palette.sunYellow30.main,
                    borderRadius: "12px",
                    color: theme.palette.white.main,
                },
            },
            filledInfo: {
                border: `1px solid ${theme.palette.neutralGray30.main}`,
                backgroundColor: theme.palette.white.main,
                color: theme.palette.neutralGray100.main,
                "& .MuiAlert-icon": {
                    color: theme.palette.deepBlue.main,
                },
                "& .MuiIconButton-root": {
                    background: theme.palette.neutralGray30.main,
                    borderRadius: "12px",
                    color: theme.palette.white.main,
                },
            },
            outlinedInfo: {
                border: `1px solid ${theme.palette.neutralGray30.main}`,
                background: theme.palette.neutralGray10.main,
                color: theme.palette.neutralGray100.main,
                "& .MuiAlert-icon": {
                    color: theme.palette.neutralGray100.main,
                },
                "& .MuiIconButton-root": {
                    background: theme.palette.neutralGray30.main,
                    borderRadius: "12px",
                    color: theme.palette.white.main,
                },
            },
        },
    };
};
